import type { AOrder } from "../types";
import { useState } from "#imports";

/**
 * Basket data held in Nuxt state
 */
export const useBasketState = () => useState<AOrder | null>( "basket", () => null );
